import './works.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {SendMessage} from "../../redux/actions";
import {connect} from "react-redux";
import {Link, useParams} from "react-router-dom";
import {getUrlWithLocal} from "../../utils/getUrlWithLocal";
import {generateFileMediaUrl} from "../../utils/generateMediaUrl";
import React, {useEffect, useRef, useState} from "react";
import {WorkDropDownIcon} from "../../assets/images";
import {WORKS_TYPES} from "../../constants/constants";


function Works(props){
    const {works,staticTexts,selectedLanguage} = props
    const [worksList, setWorksList] = useState(null);
    const params = useParams();
    const [selectedWorks, setSelectedWorks] =  useState({
        key:WORKS_TYPES[0]?.key,
        title:WORKS_TYPES[0].title,
    });
    const [openDropDown, setOpenDropDown] =  useState(false);
    const dropDownRef = useRef();

    useEffect(()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },[])

    useEffect(() => {
        setSelectedWorks(WORKS_TYPES.find((item) => item?.key === params?.type))
        if(params?.type.includes('completed')){
            setWorksList(works?.filter(work => work?.isFinished === true));
        }else if(params?.type.includes('current')){
            setWorksList(works?.filter(work => work?.isFinished === false));
        }else {
            setWorksList(works)
        }
    }, [params?.type]);
    useEffect(() => {
        if (openDropDown) {
            window.addEventListener('click', onClickedOutSide, true)
            window.addEventListener('scroll', onClickedOutSide, true)
        } else {
            window.removeEventListener('click', onClickedOutSide, false)
            window.removeEventListener('scroll', onClickedOutSide, false)
        }
        return () => {
            window.removeEventListener('click', onClickedOutSide, true)
            window.removeEventListener('scroll', onClickedOutSide, true)
        }
    }, [openDropDown]);

    function onClickedOutSide(event) {
        const path = event.composedPath ? event.composedPath() : event.path;
        if (!path?.includes(dropDownRef?.current)) {
            setOpenDropDown(false)
        }
    }

    function SelectWorkTypes(type) {
        setSelectedWorks(type);
        setOpenDropDown(false);
    }

    return <div className={'works_wrapper'}>
        <div className={'works_header_block'}>
            <div className={'works_header_titles'}>
                <Link to={getUrlWithLocal('/home')}>{staticTexts?.works_general_link_text || 'Главная'}  /</Link>
                <span>{staticTexts?.works_page_link_text || 'Проекты'}</span>
            </div>
        </div>
        <div className={'works_content_block'}>
            <div className={'works_content_header'}>
                <div className={'works_content_title'}>
                    {staticTexts?.works_title || 'Реализованные проекты'}
                </div>
                <div className={'works_content_dropdown'} ref={dropDownRef}>
                    <div className={`works_dropdown_content ${openDropDown ? 'active_dropdown' : ''}`} onClick={()=>setOpenDropDown(!openDropDown)}>
                        {staticTexts[selectedWorks?.title]} <WorkDropDownIcon/>
                    </div>
                    <div className={`works_types_dropdown ${openDropDown ? 'open' : ''}`}>
                        {
                            WORKS_TYPES?.filter((item, index) => item?.key !== selectedWorks.key)
                                .map(type => (
                                    <Link to={getUrlWithLocal(`/works/${type?.key}`)} className="works_types_item" key={type.key} onClick={()=> SelectWorkTypes(type)}>
                                        {staticTexts[type?.title]}
                                    </Link>
                                ))
                        }
                    </div>
                </div>
            </div>
            <div className={'works_content'}>
                {
                    worksList?.length ? worksList?.map((item,index)=> {
                        return <Link to={getUrlWithLocal(`/works/detail/${item?.id}`)} className={'works_content_item'}>
                            <div className={'works_img_block'}>
                                <img src={generateFileMediaUrl(item?.mediaMain?.path)} alt="" className={'works_img'}/>
                            </div>
                            <span className={'works_item_title'}>{item?.title}</span>
                        </Link>
                    }) : ''
                }
            </div>
        </div>
    </div>

}
const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'selectedLanguage',
    'works'
]);

const mapDispatchToProps = {
    SendMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(Works);